(function() {
    'use strict';

    angular
        .module('app.bancos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/bancos',
                config: {
                    templateUrl: 'app/bancos/bancos.html',
                    controller: 'Bancos',
                    controllerAs: 'vm',
                    title: 'Bancos'
                }
            },
            {
                url: '/editar-banco/:id?',
                config: {
                    templateUrl: 'app/bancos/editarBanco.html',
                    controller: 'EditarBanco',
                    controllerAs: 'vm',
                    title: 'EditarBanco'
                }
            }
        ];
    }
})();
